import React from 'react';
import { Card, Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, CameraOutlined } from '@ant-design/icons';

const QuotationCreate = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Card>
        <Result
          icon={<CameraOutlined style={{ fontSize: 72, color: '#1890ff' }} />}
          title="手動建立報價單功能開發中"
          subTitle="目前請使用 OCR 快速建單功能，或等待此功能完成"
          extra={[
            <Button key="back" onClick={() => navigate('/quotations')}>
              <ArrowLeftOutlined /> 返回列表
            </Button>,
            <Button type="primary" key="ocr" onClick={() => navigate('/quotations/ocr')}>
              <CameraOutlined /> 使用 OCR 建單
            </Button>
          ]}
        />
      </Card>
    </div>
  );
};

export default QuotationCreate;
